import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-2 text-right text-xs" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Owner: ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Groups: ", -1 /* HOISTED */)
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row flex-wrap"
}
const _hoisted_5 = { class: "flex flex-col items-start" }
const _hoisted_6 = { class: "flex flex-row flex-wrap justify-end" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Save ")
const _hoisted_9 = {
  key: 1,
  class: "flex flex-row w-full items-center justify-between p-1"
}
const _hoisted_10 = { class: "flex flex-col w-full" }
const _hoisted_11 = { class: "flex flex-row justify-around" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { style: {"color":"grey"} }, "unknown", -1 /* HOISTED */)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "font-bold text-red-500 text-sm"
}
const _hoisted_17 = { class: "flex flex-col justify-start w-full text-xs p-4" }
const _hoisted_18 = { class: "mr-2" }
const _hoisted_19 = {
  key: 0,
  class: "text-red-500 text-xs"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AnswerInput = _resolveComponent("AnswerInput")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_SlButton = _resolveComponent("SlButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col rounded", [_ctx.showSave ? 'bg-green-200' : 'bg-blue-200']]),
    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectPlayer()))
  }, [
    _createElementVNode("p", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(_toDisplayString(_ctx.ownerName) + " ", 1 /* TEXT */),
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameGroups, (gg) => {
        return (_openBlock(), _createElementBlock("span", {
          key: gg._id
        }, _toDisplayString(gg.name), 1 /* TEXT */))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_ctx.edit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_AnswerInput, {
            modelValue: _ctx.thePlayer.profile.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.thePlayer.profile.name) = $event)),
            class: "m-2",
            mode: "text",
            label: "Name",
            border: false,
            onChange: _ctx.saveActive
          }, null, 8 /* PROPS */, ["modelValue", "onChange"]),
          _createVNode(_component_AnswerInput, {
            modelValue: _ctx.thePlayer.profile.ref,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.thePlayer.profile.ref) = $event)),
            class: "m-2",
            mode: "text",
            label: "Reference",
            border: false,
            onChange: _ctx.saveActive
          }, null, 8 /* PROPS */, ["modelValue", "onChange"]),
          _createVNode(_component_AnswerInput, {
            "boolean-value": _ctx.thePlayer.profile.deleted,
            "onUpdate:boolean-value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.thePlayer.profile.deleted) = $event)),
            class: "m-2",
            mode: "binaryChoice",
            label: "Inactive",
            border: false,
            onChange: _ctx.saveActive
          }, null, 8 /* PROPS */, ["boolean-value", "onChange"]),
          _createVNode(_component_Avatar, {
            layout: _ctx.thePlayer.profile.avatar,
            class: "w-24 h-24"
          }, null, 8 /* PROPS */, ["layout"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_AnswerInput, {
              modelValue: _ctx.thePlayer.consent.state,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.thePlayer.consent.state) = $event)),
              class: "m-2",
              mode: "singleChoice",
              border: false,
              options: _ctx.consentStateList,
              label: "Consent",
              onChange: _ctx.saveActive
            }, null, 8 /* PROPS */, ["modelValue", "options", "onChange"]),
            _createVNode(_component_AnswerInput, {
              modelValue: _ctx.thePlayer.consent.id,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.thePlayer.consent.id) = $event)),
              class: "m-2",
              mode: "text",
              border: false,
              label: "Consent ID",
              onChange: _ctx.saveActive
            }, null, 8 /* PROPS */, ["modelValue", "onChange"])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.edit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.showSave)
              ? (_openBlock(), _createBlock(_component_SlButton, {
                  key: 0,
                  id: "button-save",
                  class: "col-start-2 my-2 mr-2",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.savePlayer()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", null, [
                  (_ctx.thePlayer)
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_12, _toDisplayString(_ctx.thePlayer.profile.name) + " (" + _toDisplayString(_ctx.thePlayer.profile.ref) + ")", 1 /* TEXT */))
                    : (_openBlock(), _createElementBlock("strong", _hoisted_13, _hoisted_15)),
                  (_ctx.thePlayer.profile.deleted)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, " INACTIVE"))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, "ID: " + _toDisplayString(_ctx.thePlayer._id), 1 /* TEXT */),
                (_ctx.thePlayer.profile.deleted)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, " Note: Inactive players will not show to users, but can only be removed from Games manually "))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ])),
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2 /* CLASS */))
}